export async function showGuideUseCase(showGuideData, guideRepostitory) {
    const result = await guideRepostitory.get_guide(showGuideData);

    const entity = new guideRepostitory.model({
      id: result.data.success.arguments.settings_guide.id,
      customer: result.data.success.arguments.settings_guide.client,
      shipping_service: result.data.success.arguments.settings_guide.shipping_service,
      account: result.data.success.arguments.settings_guide.shipping_account,
      guide: result.data.success.arguments.settings_guide.tracking_guides,
      date: result.data.success.arguments.settings_guide.created_at.split("T")[0],
      weight: result.data.success.arguments.settings_guide.total_weight,
      packing: result.data.success.arguments.settings_guide.boxes_details,
      volumetric_weight: result.data.success.arguments.settings_guide.volumetric_weight,
      insurance_amount: result.data.success.arguments.settings_guide.insurance_amount,
      origin: result.data.success.arguments.settings_guide.authorized_address.state,
      destination: result.data.success.arguments.settings_guide.consignee.state,
      zone: result.data.success.arguments.settings_guide.zone,
      extended_zone: result.data.success.arguments.charge.extended_zone_cost_charged != 0 ? "guide_detail.ext_zone_apply" : "guide_detail.ext_zone_not_apply",
      status: result.data.success.arguments.settings_guide.status_history,
      guide_charge: result.data.success.arguments.charge
    })
    
    if (!entity.isValid()) {
      throw new Error("external shipment inválido");
    }

    return entity;
}